import type { CaseItem } from "../../../packages/core/src/types";
import { clusterByZoom, type CaseGeo } from "../../../packages/geo/src/cluster";
import type { BBox, Cluster } from "../../../packages/ui/src";

export type SheetState = "peek" | "half" | "full";

export function itemsInViewport(items: readonly CaseItem[], bbox: BBox | null): CaseItem[] {
  if (!bbox) return [...items];
  return items.filter((item) => item.lon === null || item.lat === null || (item.lon >= bbox[0] && item.lon <= bbox[2] && item.lat >= bbox[1] && item.lat <= bbox[3]));
}

export function isMapLocated(item: CaseItem): boolean {
  return Number.isFinite(item.lon) && Number.isFinite(item.lat) && /^\d{5}$/.test(item.sigunguCode ?? "");
}

export function mapCounts(items: readonly CaseItem[]): { total: number; located: number; unlocated: number } {
  const located = items.filter(isMapLocated).length;
  return { total: items.length, located, unlocated: items.length - located };
}

export function clustersForMap(items: readonly CaseItem[], bbox: BBox | null, zoom: number): Cluster[] {
  const cases: CaseGeo[] = items
    .filter((item) => isMapLocated(item) && (!bbox || (item.lon! >= bbox[0] && item.lon! <= bbox[2] && item.lat! >= bbox[1] && item.lat! <= bbox[3])))
    .map((item) => ({ caseId: item.id, sigunguCode: item.sigunguCode!, lon: item.lon, lat: item.lat }));
  return clusterByZoom(cases, zoom);
}

export const SHEET_STATES: readonly SheetState[] = ["peek", "half", "full"];
export const INITIAL_SHEET_STATE: SheetState = "peek";
export const TILE_TIMEOUT_MS = 8_000;
